// UserEditPage.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const UserEdit = () => {
  const { userId } = useParams();
  const navigator = useNavigate();
  const [user, setUser] = useState({
    _id: "",
    name: "",
    email: "",
    password: "",
    address: "",
    type: "",
    __v: 0,
  });
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  useEffect(() => {
    const getUser = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/blogs/userinfo/indi/${userId}`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        setUser(data);
      } catch (error) {
        console.log(error);
      }
    };

    getUser();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/userinfo/edit/${userId}`,
        {
          name: user.name,
          email: user.email,
          address: user.address,
          type: user.type,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      // Redirect to the individual user profile page after editing
      if (data.data.message === "saved successfully") {
        navigator(`/userprofiles/${userId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Typography variant="h4">Edit User</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Name"
          name="name"
          value={user.name}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Email"
          name="email"
          value={user.email}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Address"
          name="address"
          value={user.address}
          onChange={handleChange}
        />
        {/* <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            border: "1px solid #cccccc",
            borderRadius: "4px",
            padding: "15px",
            margin: "1rem 0px",
          }}
        >
          <Typography display={"inline"}>Type</Typography>
          <input
            style={{ width: "20px", height: "20px", backgroundColor: "white" }}
            label="Type"
            name="type"
            type="text"
            checked={user.isGoogleSignup}
            onChange={(e) =>
              setUser((prevUser) => ({
                ...prevUser,
                isGoogleSignup: e.target.checked,
              }))
            }
          />
        </div> */}
        <TextField
          fullWidth
          margin="normal"
          label="Type"
          name="type"
          value={user.type.toLowerCase()}
          onChange={handleChange}
        />
        <br />
        <Button type="submit" variant="contained" color="primary">
          Save Changes
        </Button>
      </form>
    </div>
  );
};
